export const TARGET_TYPE = {
  Url: 'URL',
  PageTitle: 'PAGE_TITLE',
  PageContent: 'PAGE_CONTENT',
  Category: 'CATEGORY',
  CustomLabel: 'CUSTOM_LABEL',
};

export const TARGET_TYPE_MAP = {
  URL: 'URL',
  PAGE_TITLE: 'Page title',
  PAGE_CONTENT: 'Page content',
  CATEGORY: 'Category',
  CUSTOM_LABEL: 'Custom label',
};

export const CONDITION_OPERATOR = {
  Contains: 'Contains',
  Equals: 'Equals',
};

export const RULE_SEPERATOR = ' ・ ';

export const MAX_VALUE_LENGTH = 2048;

export const RULE_TYPE = {
  Url: 'URL',
  CustomLabel: 'CUSTOM_LABEL',
};
